import React, { Component } from 'react';
import { fetchUserProfile } from '../../services/Coam';

class ReadableUserSub extends Component {
  static defaultProps = {};

  static propTypes = {
    userSub: true
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      readableSub: props.userSub
    };
  }

  componentDidMount() {
    this.props.userSub
      ? fetchUserProfile(this.props.userSub)
          .then(readableSub =>
            this.setState({
              readableSub,
              loading: false
            })
          )
          .catch(err => this.setState({ loading: false, readableSub: this.props.userSub }))
      : this.setState({ loading: false });
  }

  render() {
    const { loading, readableSub = null } = this.state;
    return loading ? <i className="fa fa-spinner fa-spin" /> : readableSub;
  }
}

export default ReadableUserSub;
